import { useMemo, useState } from 'react';
import { Combobox } from 'baseui/combobox';
import { ALPHA_PROJECT_TYPES } from '../../constants';
export function TypesCombobox({
  row,
  onTypeChange
}) {
  const [value, setValue] = useState(row.type ?? '');
  const searchResults = useMemo(() => {
    return ALPHA_PROJECT_TYPES.filter(option => option.toLowerCase().includes(value.toLowerCase()));
  }, [value]);
  return <Combobox value={value} onChange={value => setValue(value)} onBlur={() => onTypeChange(row.id, value)} options={searchResults} mapOptionToString={option => option} />;
}
export default TypesCombobox;